// Avatar and user display utilities

/**
 * Get initials from name and surname
 */
export const getInitials = (name, surname = '') => {
  if (!name && !surname) return 'U';

  if (surname) {
    return `${name?.charAt(0) || ''}${surname?.charAt(0) || ''}`.toUpperCase();
  }

  // If only name is provided, try to split it
  const names = name.split(' ');
  if (names.length >= 2) {
    return `${names[0].charAt(0)}${names[1].charAt(0)}`.toUpperCase();
  }

  return name.charAt(0).toUpperCase();
};

/**
 * Get a consistent avatar color based on name
 */
export const getAvatarColor = (name) => {
  const colors = [
    'bg-gradient-to-r from-blue-500 to-blue-600',
    'bg-gradient-to-r from-green-500 to-green-600',
    'bg-gradient-to-r from-purple-500 to-purple-600',
    'bg-gradient-to-r from-red-500 to-red-600',
    'bg-gradient-to-r from-yellow-500 to-yellow-600',
    'bg-gradient-to-r from-orange-500 to-orange-600',
    'bg-gradient-to-r from-cyan-500 to-cyan-600',
    'bg-gradient-to-r from-lime-500 to-lime-600',
    'bg-gradient-to-r from-pink-500 to-pink-600',
    'bg-gradient-to-r from-indigo-500 to-indigo-600'
  ];
  const index = (name?.charCodeAt(0) || 0) % colors.length;
  return colors[index];
};
